module.exports = __webpack_public_path__ + "static/media/tours.ae89ce54.jpeg";